module Meevo.Components.Controls.SmartMover {
    import Manufacturer = Model.Manufacturer;

    export class CoreProductCatToManufacturersStrategy implements ICollectionPopulate {
        constructor(private parent: ICollectionBase<Manufacturer>, private child: ICollectionBase<Meevo.Model.ProductCategory>) {
        }

        populate(): void {
            const groups = _.groupBy(this.child.models, cat => cat.get('manufacturerId'));
            for (const manufacturer of this.parent.models) {
                const manufacturerId = manufacturer.get('id');
                const categories = groups[manufacturerId] || [];
                (<ISmartMoverCategoryModel<Manufacturer>>manufacturer).resetModels(categories);
            }
        }
    }
}